"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseMetadataProperty = exports.SongMetadataProperty = void 0;
var SongMetadataProperty;
(function (SongMetadataProperty) {
    SongMetadataProperty["Title"] = "TITLE";
    SongMetadataProperty["TitleEN"] = "TITLEEN";
    SongMetadataProperty["TitleJA"] = "TITLEJA";
    SongMetadataProperty["TitleCN"] = "TITLECN";
    SongMetadataProperty["TitleTW"] = "TITLETW";
    SongMetadataProperty["TitleKO"] = "TITLEKO";
    SongMetadataProperty["Subtitle"] = "SUBTITLE";
    SongMetadataProperty["SubtitleEN"] = "SUBTITLEEN";
    SongMetadataProperty["SubtitleJA"] = "SUBTITLEJA";
    SongMetadataProperty["SubtitleCN"] = "SUBTITLECN";
    SongMetadataProperty["SubtitleTW"] = "SUBTITLETW";
    SongMetadataProperty["SubtitleKO"] = "SUBTITLEKO";
    SongMetadataProperty["BPM"] = "BPM";
    SongMetadataProperty["Wave"] = "WAVE";
    SongMetadataProperty["Offset"] = "OFFSET";
    SongMetadataProperty["DemoStart"] = "DEMOSTART";
    SongMetadataProperty["Genre"] = "GENRE";
    SongMetadataProperty["ScoreMode"] = "SCOREMODE";
    SongMetadataProperty["Maker"] = "MAKER";
    SongMetadataProperty["Lyrics"] = "LYRICS";
    SongMetadataProperty["SongVol"] = "SONGVOL";
    SongMetadataProperty["SEVol"] = "SEVOL";
    SongMetadataProperty["Side"] = "SIDE";
    SongMetadataProperty["Life"] = "LIFE";
    SongMetadataProperty["Game"] = "GAME";
    SongMetadataProperty["HeadScroll"] = "HEADSCROLL";
    SongMetadataProperty["BGImage"] = "BGIMAGE";
    SongMetadataProperty["BGMovie"] = "BGMOVIE";
    SongMetadataProperty["MovieOffset"] = "MOVIEOFFSET";
})(SongMetadataProperty = exports.SongMetadataProperty || (exports.SongMetadataProperty = {}));
var CourseMetadataProperty;
(function (CourseMetadataProperty) {
    CourseMetadataProperty["Course"] = "COURSE";
    CourseMetadataProperty["Level"] = "LEVEL";
    CourseMetadataProperty["Balloon"] = "BALLOON";
    CourseMetadataProperty["ScoreInit"] = "SCOREINIT";
    CourseMetadataProperty["ScoreDiff"] = "SCOREDIFF";
    CourseMetadataProperty["BalloonNor"] = "BALLOONNOR";
    CourseMetadataProperty["BalloonExp"] = "BALLOONEXP";
    CourseMetadataProperty["BalloonMas"] = "BALLOONMAS";
    CourseMetadataProperty["Style"] = "STYLE";
    CourseMetadataProperty["Exam1"] = "EXAM1";
    CourseMetadataProperty["Exam2"] = "EXAM2";
    CourseMetadataProperty["Exam3"] = "EXAM3";
    CourseMetadataProperty["GaugeIncr"] = "GAUGEINCR";
    CourseMetadataProperty["Total"] = "TOTAL";
    CourseMetadataProperty["HiddenBranch"] = "HIDDENBRANCH";
})(CourseMetadataProperty = exports.CourseMetadataProperty || (exports.CourseMetadataProperty = {}));
